import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useStartAiReviewMutation = (mode: 'authorized' | 'guest') => {
  const { sims } = useAvApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['ai-review', 'start'],
    mutationFn: async ({
      scenarioId,
      persona,
    }: {
      scenarioId: string;
      persona: 'accessible' | 'default' | string;
    }) => {
      if (!scenarioId || !mode) return;

      if (mode === 'authorized') {
        const res = await sims.postSimulationSingleById(
          null,
          {
            id: scenarioId,
          },
          {
            persona,
          }
        );

        return res.data;
      }

      if (mode === 'guest') {
        const res = await sims.postGuestSimulationSingleById(null, {
          id: scenarioId,
        });

        return res.data;
      }

      return null;
    },
    onSuccess: (_, { scenarioId }) => {
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews', scenarioId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-latest-review', scenarioId],
        refetchType: 'all',
      });
    },
  });
};
